import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder_inHours: {
    id: 'kustomer.chat.form.input.placeholder.inHours',
    description: 'Convo form placeholder for in business hours',
    defaultMessage: 'Type a message...',
  },
  placeholder_afterHours: {
    id: 'kustomer.chat.form.input.placeholder.afterHours',
    description: 'Convo form placeholder for after business hours',
    defaultMessage: 'Leave a message...',
  },
});
